export interface AccountLanguage {
  code: string;
  name: string;
  flag: string;
}

export const accountLanguages: AccountLanguage[] = [
  { code: '', name: 'languages.none', flag: '' },
  { code: 'en', name: 'languages.english', flag: 'gb' },
  { code: 'sv', name: 'languages.swedish', flag: 'se' },
  { code: 'da', name: 'languages.danish', flag: 'dk' },
  { code: 'nl', name: 'languages.dutch', flag: 'nl' },
  { code: 'fi', name: 'languages.finnish', flag: 'fi' },
  { code: 'fr', name: 'languages.french', flag: 'fr' },
  { code: 'de', name: 'languages.german', flag: 'de' },
  { code: 'hu', name: 'languages.hungarian', flag: 'hu' },
  { code: 'it', name: 'languages.italian', flag: 'it' },
  { code: 'no', name: 'languages.norwegian', flag: 'no' },
  { code: 'pl', name: 'languages.polish', flag: 'pl' },
  { code: 'pt', name: 'languages.portuguese', flag: 'pt' },
  { code: 'ro', name: 'languages.romanian', flag: 'ro' },
  { code: 'es', name: 'languages.spanish', flag: 'es' },
  { code: 'uk', name: 'languages.ukrainian', flag: 'ua' },
];
